import { create } from "zustand";
import { persist } from "zustand/middleware";
import { isThemeName, type ThemeName } from "@/betby/theme";
import { getThemeQueryParam } from "@/betby/adapters/router/queryParamsAdapter";
import {
  createAppConfigPersistStorage,
  PERSIST_STORAGE_NAMES,
} from "@/betby/store/persistStorage";

interface ThemeState {
  theme: ThemeName;
  _hasHydrated: boolean;
  setTheme: (theme: ThemeName) => void;
  syncThemeWithUrl: () => void;
  setHasHydrated: (state: boolean) => void;
}

type PersistedThemeState = Pick<ThemeState, "theme">;

function getThemeFromUrl(): ThemeName | null {
  const themeFromUrl = getThemeQueryParam();
  return isThemeName(themeFromUrl) ? themeFromUrl : null;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: "poly",
      _hasHydrated: false,
      setTheme: (theme) => {
        set({ theme });
      },
      syncThemeWithUrl: () => {
        const urlTheme = getThemeFromUrl();
        if (urlTheme) {
          get().setTheme(urlTheme);
        }
      },
      setHasHydrated: (state) => set({ _hasHydrated: state }),
    }),
    {
      name: PERSIST_STORAGE_NAMES.theme,
      storage: createAppConfigPersistStorage<PersistedThemeState>("theme"),
      partialize: (state): PersistedThemeState => ({
        theme: state.theme,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          const urlTheme = getThemeFromUrl();
          if (urlTheme) {
            state.setTheme(urlTheme);
          }
          state.setHasHydrated(true);
        }
      },
    },
  ),
);
